module.exports = __webpack_public_path__ + "img/vi.17627cb2.png";